export const shopify = {
  // TODO 数据库配置 id=14
  /**
   * @url https://www.ferventoys.com/
   */
  13: 'l0wjryo8',

  /**
   * @url https://allbuy.com/
   */
  30: 'l2y7m6c5',

  /**
   * @url https://www.piscifun.com/
   */
  33: 'l3e7lpim',

  /**
   * @url https://445a38.myshopify.com/
   * @deprecated
   * @description 测试站点
   */
  145: 'lb08lu3r',

  /**
   * @url https://oglmove.com/
   */
  328: 'lf0hi4rj',

  /**
   * @url https://silksilky.com/
   */
  565: 'lk7rs0uo',

  /**
   * @url https://uk.silksilky.com/
   */
  578: 'll5wdjt8',

  /**
   * @url https://de.silksilky.com/
   */
  579: 'll5x8dhs',

  /**
   * @url https://www.splendiday.com/
   */
  583: 'll67j061',

  /**
   * @url https://customtestaddcart.myshopify.com/
   */
  721: 'lpujne54',

  /**
   * @url https://www.cherrykitten.com/
   */
  724: 'lpw1l92w',

  /**
   * @url https://curvy-faja.com.mx/
   */
  902: 'lt80etle',

  /**
   * @url https://www.popilush.com/
   */
  907: 'ltgknrsm',

  /**
   * @url https://cosyisland.co/
   */
  920: 'lu279wve',

  /**
   * @url https://www.martclothing.com/
   */
  926: 'lu9se710',

  /**
   * @url https://previewall.myshopify.com/
   * @description 测试站点
   */
  994: 'lvdizz5a',

  /**
   * @url https://www.soulisfree.com/
   * @deprecated
   */
  1034: 'lvym6j31',

  /**
   * @url https://www.qvr.com/
   */
  1291: 'lysgtta1',

  /**
   * @url https://us.donnermusic.com/
   */
  1292: 'lywljpfz',

  /**
   * @url https://itehil.com/
   */
  1342: 'lzutpmqn',

  /**
   * @url https://www.classyoutlaw.com/
   */
  1378: 'm0g47vyg',

  /**
   * @url https://www.songmics.de/
   */
  1379: 'm0gbi43k',

  /**
   * @url https://www.tailtells.com/
   */
  1510: 'm25n5298',

  /**
   * @url https://louilyjewelry.com/
   */
  1596: 'm3e9b2bs',

  /**
   * @url https://orionride.com
   */
  1598: 'm3fm2r6d',

  /**
   * @url https://www.broncobay.com/
   */
  1682: 'm4m67lht',

  /**
   * @url https://linticoshop.com/
   */
  1756: 'm524ccg7',

  /**
   * @url https://www.songmics.com/
   */
  1929: 'm72qtqqx',

  /**
   * @url https://www.hookrun.com/
   */
  2095: 'm8xwogy7',

  /**
   * @url https://www.ironpandafit.com
   */
  2152: 'm9c5nqdu',

  /**
   * @url https://www.cvlife.com/
   */
  2247: 'm9whqjq0',

  /**
   * @url https://shopmicas.com/
   */
  2317: 'marvl4cv',

  /**
   * @url https://www.ievilenergy.com/
   */
  2336: 'mawd0qfk',

  /**
   * @url https://www.evilnova.com
   */
  2377: 'mb7bcmnk',

  /**
   * @url https://idooodle.com/
   */
  2443: 'mbt7k910',

  /**
   * @url https://hallidayglobal.com/
   */
  2545: 'mcvr1ayc',

  /**
   * @url https://www.fioboc.com/
   */
  2631: 'mdps1ko6',

  /**
   * @url https://www.uoozee.com/
   */
  2658: 'mdy7tqmu',

  /**
   * @url https://www.urcustom.com/
   */
  2719: 'me9j8d9f'
};

export const shopline = {
  /**
   * @url https://www.37bracelets.com/
   */
  327: 'lezd196i',

  /**
   * @url https://curvy-faja.com/
   */
  475: 'lhe9xn2g',

  /**
   * @url https://7mgv3.myshopline.com/
   * @description 测试站点
   */
  621: 'lnjzugty',

  /**
   * @url https://www.bellabarnett.com/
   */
  641: 'lom9e5qw',

  /**
   * @url https://lilybeauty.myshopline.com/
   * @description 正式的测试站点
   */
  678: 'lphyggtq',

  /**
   * @url https://www.beepumpkin.com/
   */
  689: 'lpkl9d1b',

  /**
   * @url https://dataiyang.myshopline.com/
   */
  705: 'lpnpjy9f',

  /**
   * @url https://www.guidingcross.com/
   */
  838: 'lqoxklaw',

  /**
   * @url https://www.boldoversize.com/
   */
  884: 'lsyakded',

  /**
   * @url https://www.cowboybay.com/
   */
  895: 'lt5qvkfr',

  /**
   * @url https://www.unibling.com/
   */
  1081: 'lwq5wwol',

  /**
   * @url https://www.jessemade.com/
   */
  1316: 'lzchokwb',

  /**
   * @url https://www.jessemade.co.uk/
   */
  1320: 'lzcjvp3t',

  /**
   * @url https://lovellx.com/
   */
  1377: 'm0f4wzan',

  /**
   * @url https://www.purplehecate.com/
   * @deprecated
   */
  1451: 'm1epsjy9',

  /**
   * @url https://www.allisokay.com/
   * @deprecated
   */
  1459: 'm1fxt0wj',

  /**
   * @url https://www.pagewings.com/
   */
  1535: 'm2ms0nkj',

  /**
   * @url https://www.nerdywave.com/
   */
  1657: 'm49cgvca',

  /**
   * @url https://www.tokyo-tiger.com/
   */
  1661: 'm4ckcpn5',

  /**
   * @url https://www.goodnurselife.com
   */
  1737: 'm50ms2y1',

  /**
   * @url https://www.cherryswing.com/
   */
  1739: 'm50rrlwo',

  /**
   * @url https://www.classyoutlaw.com/
   */
  2096: 'm8xwss7h',

  /**
   * @url https://www.mobiusdollar.com
   */
  2123: 'm97vakrm',

  /**
   * @url https://www.geeksoutfit.com
   */
  2244: 'm9wf5r83',

  /**
   * @url https://www.soulisfree.com
   */
  2273: 'ma671ns8',

  /**
   * @url https://www.tokyotiger.com
   */
  2452: 'mbyl8gao',

  /**
   * @url https://www.broncobay.com/
   */
  2641: 'mdsfmnj8',

  /**
   * @url https://www.megacustom.com/
   */
  2691: 'me13xe4n',

  /**
   * @url https://www.maturelion.com/
   */
  2783: 'mewgfnzg'
};

export const shoplazza = {
  /**
   * @url https://www.mewaii.com/
   */
  283: 'le5j5uh8',

  /**
   * @url https://cartsee-test1218.myshoplaza.com/
   * @description 测试站点
   */
  306: 'leca9wq8',

  /**
   * @url https://www.veirousa.com/
   */
  317: 'lembmevv',

  /**
   * @url https://cicicocoly.myshoplaza.com/
   * @description 混合测试站
   */
  671: 'lpgoyvck',

  /**
   * @url https://www.panymore.com/
   */
  1028: 'lvvzhe89',

  /**
   * @url https://www.greecove.com/
   */
  1335: 'lzqrx1iu',

  /**
   * @url https://www.posyoga.com
   */
  1358: 'm03ovy19'
};

export const xike = {
  /**
   * @url https://test.justfashionnow.com/
   * @description 测试站点
   */
  313: 'lef9edad',

  /**
   * @url https://www.stylewe.com/
   */
  450: 'lgoitpiz',

  /**
   * @url https://www.hardaddy.com/
   */
  468: 'lh90b7pi',

  /**
   * @url https://www.zolucky.com/
   */
  482: 'lhenj6ip',

  /**
   * @url https://de.stylewe.com/
   */
  529: 'liiobos9',

  /**
   * @url https://www.fehaute.com/
   */
  685: 'lpjmccnz'
};

export const common = {
  /**
   * @url https://www.missacc.com/
   */
  899: 'lt72sdrv',

  /**
   * @url https://www.nextearrings.com/
   */
  1032: 'lvxi45a1',

  /**
   * @url https://uk.missacc.com/
   */
  1182: 'lx057zya',

  /**
   * @url https://www.aoolia.com/
   */
  1299: 'lz7tbejw',

  /**
   * @url https://www.helloice.com/
   */
  1334: 'lzmfum6u',

  /**
   * @url https://www.70mai.com
   */
  1384: 'm0kp0l6b',

  /**
   * @url https://apparel.helloice.com/
   */
  1527: 'm2ig0ot8',

  /**
   * @url https://www.aoolia.de/
   */
  1536: 'm2mxyki3',

  /**
   * @url https://www.aoolia.fr/
   */
  1545: 'm2oc5jt8',

  /**
   * @url https://www.aoolia.it/
   */
  1546: 'm2ocj1yo',

  /**
   * @url https://m.sakerplus.com/
   * @description 有橙
   */
  1557: 'm2vasq26',

  /**
   * @url https://example.saas.ycimedia.net/
   * @description 有橙测试站点
   */
  1558: 'm2vh6098',

  /**
   * @url https://www.comfyboutiques.com/
   */
  1561: 'm2wwg5pq',

  /**
   * @url https://lynneo.fun/
   * @description 羿扬测试站点
   */
  1565: 'm2y2ftjf',

  /**
   * @url https://au.missacc.com/
   */
  1804: 'm5avvsl5',

  /**
   * @url https://ca.missacc.com/
   */
  1881: 'm5xagbu6',

  /**
   * @url https://de.missacc.com/
   */
  1882: 'm5xaize1',

  /**
   * @url https://fr.missacc.com/
   */
  1883: 'm5xajsgq',

  /**
   * @url https://www.povison.com/
   */
  1892: 'm60hnp9c',

  /**
   * @url https://de.helloice.com/
   */
  1997: 'm7vj0nak',

  /**
   * @url https://www.drawmade.com/
   */
  2016: 'm85ey3zj',

  /**
   * @url https://uk.aoolia.com/
   */
  2107: 'm8z8o33s',

  /**
   * @url https://es.aoolia.com/
   */
  2109: 'm8ze5ga8',

  /**
   * @url https://mx.aoolia.com/
   */
  2110: 'm8ze6hu3',

  /**
   * @url https://ca.povison.com/
   */
  2042: 'm8fdshe8',

  /**
   * @url m8flvlv6
   */
  2044: 'm8flvlv6',

  /**
   * @url https://de.povison.com/
   */
  2058: 'm8ij13ax',

  /**
   * @url https://test1.musem.com/
   */
  2059: 'm8ij3bc0',

  /**
   * @url https://fr.povison.com/
   */
  2075: 'm8r14nd2',

  /**
   * @url https://it.povison.com/
   */
  2076: 'm8r154vu',

  /**
   * @url https://sit.povison.com/
   */
  2131: 'm99bbule',

  /**
   * @url https://casit.povison.com/
   */
  2133: 'm90mbupx',

  /**
   * @url https://www.drawelryde.com/
   */
  2306: 'maooofcd',

  /**
   * @url https://heyprom.com/
   */
  2183: 'm9cgq54t',

  /**
   * @url https://uk.heyprom.com/
   */
  2362: 'mb0kt91f',

  /**
   * @url https://au.heyprom.com/
   */
  2363: 'mb0ku1mv',

  /**
   * @url https://ca.heyprom.com/
   */
  2364: 'mb0kzik2',

  /**
   * @url https://de.heyprom.com/
   */
  2365: 'mb0l0a1x',

  /**
   * @url https://fr.heyprom.com/
   */
  2366: 'mb0l0xwt',

  /**
   * @url https://www.drawelry.com.mx/
   */
  2457: 'mbzxqyaj',

  /**
   * @url https://www.drawelryes.com/
   */
  2458: 'mbzzepbl',

  /**
   * @url https://www.customman.store
   */
  2558: 'mcy99ocf'
};

export const woocommerce = {
  /**
   * @url https://www.recoolhair.com/
   */
  1246: 'lxo2fvyw',

  /**
   * @url https://www.celiehair.com/
   */
  1247: 'lxo69kow',

  /**
   * @url https://0625.celiehair.com/
   * @description 测试站点
   */
  1294: 'lyxvjtdb'
};

const all = {
  ...xike,
  ...common,
  ...shopify,
  ...shopline,
  ...shoplazza,
  ...woocommerce
};

// companyUUID -> companyId
const map = {};
for (const key in all) {
  map[all[key]] = +key;
}

export const config = {
  xike,
  common,
  shopify,
  shopline,
  shoplazza,
  ...map
};
